module.exports = __webpack_public_path__ + "static/img/14000669.911cc7de.png";